import axios from "axios";
import React, {useEffect, useState} from "react";
import '../../styles/global.css'; // Seu CSS global
import { useParams, useNavigate } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { SwapVert, ThumbUpAlt, ThumbDownOffAlt } from '@mui/icons-material';

function Aviso() {
    //constants
    const { idaviso } = useParams();
    const navigate = useNavigate();
    const loggedIn = sessionStorage.getItem('loggedIn');
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [avisoInfo, setAvisoInfo] = useState([]);
    const tokenAPI = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
    const [bloqueio, setBloqueio] = useState(false);
    const now = new Date();
    const customFormatDate = new Intl.DateTimeFormat('pt-BR', {
    year: 'numeric',
    day: '2-digit',
    month: '2-digit',
    hour: 'numeric',
    minute: 'numeric',
    second: 'numeric',
    hour12: false
    }).format(now).replace(/\//g, '/').replace(',',''); // Replace slashes with hyphens
    const uuid = customFormatDate.replace('-', '').replace(' ', '').replace(':', '').replace(':', '').replace('/', '').replace('/', '');    
    const [aviso, setAviso] = useState({
        IdAviso: idaviso !== undefined && parseInt(idaviso) ? parseInt(idaviso) : 0,
        aviTitulo: '',
        aviDescricao: '',
        aviObservacoes: '',
        aviTransmitir: 0,
        aviCentral: 1,
        aviStatus: 1,
        aviCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'Usuário Desconecido',
        aviCriadoEm: customFormatDate,
        aviAlteradoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'Usuário Desconecido',
        aviAlteradoEm: customFormatDate,
        aviCodigoGUID: uuid + '-'+ Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    });

    const [pessoas, setPessoas] = useState([]);
    const [selectedPessoas, setSelectedPessoas] = useState([]);
    const [leitores, setLeitores] = useState([]);

    // console.log(pessoas);
    // console.log(selectedPessoas);

    //carrega pessoas
    useEffect(() => {
        //if (aviso && aviso.IdAviso === 0) {
            var token = "ae28b7ca-7db9-11ee-aa2d-fa163e6e2f00";
            setIsLoading(true);
        
            axios
            .get(
            process.env.REACT_APP_API_URL +
            '/routes.php?metodo=obterAssociadosAtivos',
            { headers: { 
                "X-Access-Token": token,
                "Content-Type": "application/json; charset=UTF-8"
            } }
            )
            .then(response => {
            setPessoas(response.data)
            setIsLoading(false);
            })
            .catch(error => {
            let ret = error.message;
            setIsLoading(false);
            if (ret.includes("401")) {
                console.log("token inválido!")
            }
            })
        //}
    }, []);

    const toggleSelectedPessoa = (pessoa) => {
        setSelectedPessoas(prevSelected => {
            const jaSelecionada = prevSelected.some(p => p.IdPessoa === pessoa.IdPessoa);
            if (jaSelecionada) {
                return prevSelected.filter(p => p.IdPessoa !== pessoa.IdPessoa);
            } else {
                return [...prevSelected, pessoa];
            }
        });
    };
    
    // Determina se TODAS as pessoas estão selecionadas atualmente
    const todasSelecionadas = selectedPessoas.length === pessoas.length;
    // Função para selecionar ou deselecionar todo mundo
    const toggleSelecionarTodos = () => {
        if (selectedPessoas.length === pessoas.length) {
        // Se todas já estavam selecionadas, esvazia o estado
        setSelectedPessoas([]);
        } else {
        // Se não, coloca todas as pessoas da lista no estado
        setSelectedPessoas([...pessoas]);
        }
    };

    //effects
    //envia para login se não estiver logado
    useEffect(() => {
        if (loggedIn === false || loggedIn === null || loggedIn === undefined)
        {
            navigate('/Login');
            window.location.reload();
        }
    }, []);
    //carrega informações do aviso se o ID estiver definido
    useEffect(() => {
        if (idaviso !== undefined && parseInt(idaviso) > 0)
        {
            setIsLoading(true);

            const dados = {
                IdAviso: idaviso            
            };

            axios
            .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=obterAviso', 
                dados, {
                headers: {
                    "X-Access-Token": tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            })
            .then(response => {
                if (response.data) {
                    const data = response.data[0];
                    setAvisoInfo(data);
                    setAviso(response.data[0]);
                    setIsLoading(false);
                    marcarLeitura();
                } else {
                    alert('Aviso não encontrado. Por favor, verifique o ID do aviso e tente novamente.');
                    setIsLoading(false);
                    navigate('/Avisos');
                }
            })
            .catch(error => {
                console.log('Erro ao buscar informações do aviso:', error);
                alert('Ocorreu um erro ao carregar as informações do aviso. Por favor, tente novamente mais tarde.');
                setIsLoading(false);
                navigate('/Avisos');
            });
        }
    }, [idaviso]);
    //carrega pessoas que leram o aviso
    useEffect(() => {
        if (idaviso !== undefined && parseInt(idaviso) > 0)
        {
            const dados = {
                IdAviso: idaviso            
            };

            axios
            .post(process.env.REACT_APP_API_URL + 
                '/routes.php?metodo=obterPessoasQueLeramAviso', 
                dados, {
                headers: {
                    "X-Access-Token": tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            })
            .then(response => {
                if (response.data) {
                    setLeitores(response.data);
                } else {
                    setLeitores([]);
                }
            })
            .catch(error => {
                console.log('Erro ao buscar pessoas que leram o aviso:', error);
                setLeitores([]);
            });
        }
    }, [idaviso]);

    //functions
    function handleVoltar() {
        navigate('/Avisos');
    }
    function handleFecharModal() {
        window.history.back();
    }
    function handleInputChange(event) {
        const { name, value } = event.target;
        setAviso(prevState => ({
            ...prevState,
            [name]: value
        }));
        }
    function handleCheckboxChange(event) {
        const { name, checked } = event.target;
        setAviso(prevState => ({
            ...prevState,
            [name]: checked ? 1 : 0
        }));
    }
    function handleFormSubmit(event) {
        event.preventDefault();
        if (parseInt(aviso.aviTransmitir) === 1 && selectedPessoas.length === 0) {
            alert('Aviso não pode ser transmitido sem selecionar os associados.');
            return; // Adiciona um retorno para impedir que o formulário seja enviado
        }
        if(!bloqueio){
            setBloqueio(true);
            const dados = {
                IdAviso: aviso.IdAviso,
                aviTitulo: aviso.aviTitulo,
                aviDescricao: aviso.aviDescricao,
                aviObservacoes: aviso.aviObservacoes,
                aviTransmitir: aviso.aviTransmitir,
                aviCentral: aviso.aviCentral,
                aviStatus: aviso.aviStatus,
                aviCriadoPor: aviso.aviCriadoPor,
                aviCriadoEm: aviso.aviCriadoEm,
                aviAlteradoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : 'Usuário Desconecido',
                aviAlteradoEm: customFormatDate,
                aviCodigoGUID: aviso.aviCodigoGUID
            };
            let urlAPI = "";
            if(aviso.IdAviso === 0) {
                urlAPI = process.env.REACT_APP_API_URL + '/routes.php?metodo=novoAviso';
            }
            else {
                urlAPI = process.env.REACT_APP_API_URL + '/routes.php?metodo=alterarAviso';
            }
            axios
            .post(urlAPI, 
                dados, {
                headers: {
                    "X-Access-Token": tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            })
            .then(response => {
                if (response.data) {
                    console.log('Aviso salvo com sucesso!');
                    //console.log(aviso.IdAviso + " - "+ aviso.aviTransmitir);
                    if(parseInt(aviso.aviTransmitir) === 1) {
                        if (window.confirm('Aviso será enviado por email para os associados selecionados!')){
                            enviarEmailsAssociados();
                        }
                    } else {
                        alert('Esse aviso não será enviado por email.');
                    }
                    navigate('/Avisos');
            }})
            .catch(error => {
                console.log('Erro ao salvar o aviso:', error);
                alert('Ocorreu um erro ao salvar o aviso. Por favor, tente novamente mais tarde.');
            })
            .finally(() => {
                setBloqueio(false);
            });
        }
    }
    async function enviarEmailsAssociados(){
        for ( const associado of selectedPessoas) {
            if(!associado.pesEmail) {
                console.log('Associado ' + associado.pesNome + ' não possui email cadastrado. Email não enviado.');
                //return;
            } else {
                if(!associado.pesEmail) {
                    console.log('Associado ' + associado.pesNome + ' não possui email cadastrado. Email não enviado.');
                    //return;
                } else {
                    await new Promise(resolve => setTimeout(resolve, 3000));
                    var corpoEmail = `<div style="margin: 0px; width: 100vw; height: 100vh; color: white; background-color: black; font-family: Arial, Helvetica, sans-serif;">
                        <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                            <img width="200px" src="https://www.brasilextremos.com.br/api/uploads/fotos/logo_mgbe.png" alt="logoMGBE"/>
                        </div>
                        <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                            <div style="padding-top:20px;padding-bottom:10px; max-width: 450px;font-weight:bold; font-size:14px; text-align:left;">
                                ${aviso.aviDescricao}
                            </div>
                        </div>
                        <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                            <div style="padding-top:20px;padding-bottom:10px; max-width: 350px;font-size:12px; text-align:left;">
                                ${aviso.aviObservacoes}
                            </div>
                        </div>
                        
                        <div style="width: 100%; display: flex; justify-content: center; align-items: center; padding-top: 20px;">
                            <div style="padding-top:20px;padding-bottom:10px; max-width: 150px;font-size:12px; text-align:center;">
                                <i>Gestão M.G. Brasil Extremos</i>
                            </div>
                        </div>

                        <hr />
                        <div style="font-size: 12px; color: gray; padding: 10px;">
                            O conteúdo desse e-mail é destinado apenas ao destinatário.<br />
                            Seu conteúdo é classificado como confidencial e não deve ser divulgado, copiado ou distribuído a terceiros sem autorização.<br />
                            A violação de confidencialidade e privacidade com base nas Leis de Proteção de Dados, de Propriedade Intelectual e de Regulação de Uso da Internet pode resultar em responsabilidade civil e criminal.<br />
                            Agradecemos sua compreensão e cooperação.<br />
                            <p> Se você recebeu este e-mail por engano, por favor, notifique o remetente e exclua-o imediatamente.</p>
                        </div>
                    </div>`;

                    const dadosEmail = {
                        "email": associado.pesEmail,
                            "assunto": 'MGBE - Comunicação: ' + aviso.aviTitulo,
                            "mensagem": corpoEmail
                        };
                        axios
                        .post(process.env.REACT_APP_API_URL + '/routes.php?metodo=enviarEmail', 
                            dadosEmail, {
                            headers: {
                                "X-Access-Token": tokenAPI,
                                "Content-Type": "application/json; charset=UTF-8"
                            }
                        })
                        .then(response => {
                            console.log('Resposta do envio de email para ' + associado.pesEmail + ':', response.data);
                            if (response.data.message === 'E-mail enviado com sucesso!') {
                                console.log('Email enviado para ' + associado.pesEmail);
                                salvarLog('Email enviado para ' + associado.pesEmail);
                            } else {
                                console.log('Erro ao enviar email para ' + associado.pesEmail);
                                salvarLog('Erro ao enviar email para ' + associado.pesEmail);
                            }
                        })
                        .catch(error => {
                            console.log('Erro ao enviar email para ' + associado.pesEmail + ':', error);
                            salvarLog('Erro ao enviar email para ' + associado.pesEmail + ': ' + error.message);
                            //console.error('Erro ao enviar email para ' + associado.pesEmail, error);
                        });
                }
            }
        }
    }

    function salvarLog(mensagem) {
        const log = {
        IdPessoa: sessionStorage.IdPessoa ? sessionStorage.IdPessoa : 0,
        logTipo: "AVISO - Email Associado",
        logModulo: mensagem,
        logCriadoPor: sessionStorage.nomeUsuario ? sessionStorage.nomeUsuario : "Visitante",
        logCriadoEm: new Date().toISOString(),
        logCodigoGUID: crypto.randomUUID()
        };
        axios                    
        .post(process.env.REACT_APP_API_URL 
            + '/routes.php?metodo=novoLog', 
            log, {
                headers: {
                    "X-Access-Token" : tokenAPI,
                    "Content-Type": "application/json; charset=UTF-8"
                }
            }
        )
        .then(response => {
            console.log(response.data[0].mensagem);
            //setSalvarLog(false);
        })
        .catch(error => {
            console.error('Erro ao enviar log:', error);
            //setSalvarLog(false);
        })
    }

    function marcarLeitura() {
        // Lógica para marcar o aviso como lido
    }
    
    //console logs
    //console.log(aviso);
    //console.log(idaviso);

    //render
    return (
        <div style={{ paddingBottom: '80px' }}>
            <main>
                <div>
                    {/* fechar */}
                    <div className='d-flex w100 mt1 flex-column text-align-left'>
                        <div className='text-align-left w80 fs14'>
                            <button
                                className="buttonModalPadraoLaranja fs11"
                                onClick={handleFecharModal}>Fechar
                            </button>
                        </div>
                    </div>
                    {/* form */}
                    <div>
                          {parseInt(sessionStorage.pesAdmin) === 1 ? (
                                <div>
                                    {/* <form> */}
                                        {/* Formulário de edição do aviso */}
                                        <div className="headerMain">
                                            <label className='labelTitulo fs16' >Detalhes do Aviso</label>
                                        </div>
                                        <div className="d-flex w100 flex-column tdAlignLeft pb4">
                                            {/* Titulo do Aviso */}
                                            <div className="d-flex flex-row divForm">
                                                <div className="w100">
                                                    <div className='text-align-left divForm fs16'>
                                                        <label>TÍTULO</label>
                                                    </div>
                                                    <div className='text-align-left divForm w100 fs12'>
                                                        <input
                                                        defaultValue={aviso.aviTitulo}
                                                            onChange={handleInputChange}
                                                        className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                        required
                                                        name="aviTitulo"
                                                        id="aviTitulo"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Descrição do Aviso */}
                                            <div className="d-flex flex-row divForm">
                                                <div className="w100">
                                                    <div className='text-align-left divForm fs16'>
                                                        <label>DESCRIÇÃO</label>
                                                    </div>
                                                    <div className='text-align-left divForm w100 fs12'>
                                                        <textarea
                                                        defaultValue={aviso.aviDescricao}
                                                        onChange={handleInputChange}
                                                        className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                        required
                                                        name="aviDescricao"
                                                        id="aviDescricao"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Observações do Aviso */}
                                            <div className="d-flex flex-row divForm">
                                                <div className="w100">
                                                    <div className='text-align-left divForm fs16'>
                                                        <label>OBSERVAÇÕES</label>
                                                    </div>
                                                    <div className='text-align-left divForm w100 fs12'>
                                                        <textarea
                                                        defaultValue={aviso.aviObservacoes}
                                                        onChange={handleInputChange}
                                                        className="pt1 pb1 p1 fs12 w100 text-align-left" 
                                                        required
                                                        name="aviObservacoes"
                                                        id="aviObservacoes"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Transmitir */}
                                            <div className="d-flex flex-column divForm">
                                                <div className="w100">
                                                    <div className='text-align-left divForm fs16'>
                                                        <label>TRANSMITIR</label>
                                                    </div>
                                                    <div className='text-align-left divForm w100 fs12'>
                                                        <select
                                                        onChange={handleInputChange}
                                                        className="pt1 pb1 fs16 w100 text-align-center" 
                                                        required
                                                        name="aviTransmitir"
                                                        id="aviTransmitir"
                                                        >
                                                            <option value="1" selected={aviso.aviTransmitir === 1}>SIM</option>
                                                            <option value="0" selected={aviso.aviTransmitir === 0}>NÃO</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Central */}
                                            <div className="d-flex flex-column divForm">
                                                <div className="w100">
                                                    <div className='text-align-left divForm fs16'>
                                                        <label>CENTRAL</label>
                                                    </div>
                                                    <div className='text-align-left divForm w100 fs12'>
                                                        <select
                                                        onChange={handleInputChange}
                                                        className="pt1 pb1 fs16 w100 text-align-center" 
                                                        required
                                                        name="aviCentral"
                                                        id="aviCentral"
                                                        >
                                                            <option value="1" selected={aviso.aviCentral === 1}>SIM</option>
                                                            <option value="0" selected={aviso.aviCentral === 0}>NÃO</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Status */}
                                            <div className="d-flex flex-column divForm">
                                                <div className="w100">
                                                    <div className='text-align-left divForm fs16'>
                                                        <label>STATUS</label>
                                                    </div>
                                                    <div className='text-align-left divForm w100 fs12'>
                                                        <select
                                                        onChange={handleInputChange}
                                                        className="pt1 pb1 fs16 w100 text-align-center" 
                                                        required
                                                        name="aviStatus"
                                                        id="aviStatus"
                                                        >
                                                            <option value="1" selected={aviso.aviStatus === 1}>SIM</option>
                                                            <option value="0" selected={aviso.aviStatus === 0}>NÃO</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            {/* Destinatários */}
                                            {/* {parseInt(aviso.IdAviso) === 0 ? ( */}
                                                <>
                                                    <div>
                                                        Enviar para:
                                                    </div>
                                                    {/* Botão para selecionar todos os destinatários */}
                                                    <div>
                                                        <button
                                                            onClick={toggleSelecionarTodos}
                                                            style={{
                                                            padding: '10px 20px',
                                                            marginBottom: '15px',
                                                            cursor: 'pointer',
                                                            backgroundColor: todasSelecionadas ? '#ffcdd2' : '#c8e6c9',
                                                            border: '1px solid #bdb4b4',
                                                            borderRadius: '4px',
                                                            fontWeight: 'bold'
                                                            }}
                                                            >
                                                            {todasSelecionadas ? 'Desmarcar Todos' : 'Enviar para Todos'}
                                                        </button>
                                                    </div>
                                                    {/* Lista de destinatários */}
                                                    <div className={`d-flex flex-column divForm fs09`} 
                                                    style={{ backgroundColor: '#cbc7c7', padding: '5px', borderRadius: '5px' }}>
                                                        {pessoas ? 
                                                        pessoas
                                                        .filter(pessoa => {
                                                            if(parseInt(pessoa.pesStatus) === 1 && parseInt(pessoa.pesAssociado) === 1) {
                                                                return pessoa;
                                                            }
                                                        })
                                                        .map(pessoa => {
                                                            const leuAviso = leitores.some((l) => l.IdPessoa === pessoa.IdPessoa);
                                                            const estaSelecionada = selectedPessoas.some((p) => p.IdPessoa === pessoa.IdPessoa); 
                                                                return (
                                                                <div key={pessoa.IdPessoa}
                                                                    onClick={() => toggleSelectedPessoa(pessoa)}
                                                                     
                                                                    style={{ width: '100%', borderRadius: '5px', padding: '5px', cursor: 'pointer', backgroundColor: estaSelecionada ? '#507455' : '#5c5a5a' }} >
                                                                    <div
                                                                    
                                                                    style={{ padding: '3px', textAlign: 'left', paddingTop: '5px' }}>
                                                                        <p style={{ width: '100%' }}><b>{pessoa.pesNome}</b></p> 

                                                                        <div style={{ padding: '6px', textAlign: 'left', width: '100%' }}>
                                                                            <br /><span style={{ fontStyle: 'italic', fontSize: '0.8em' }}>{pessoa.pesEmail.split('@')[0]}</span>
                                                                            <br /><span style={{ fontStyle: 'italic', fontSize: '0.7em' }}>@{pessoa.pesEmail.split('@')[1]}</span>
                                                                            <br /><span style={{ fontStyle: 'italic', fontSize: '0.9em' }}>{pessoa.pesCelular}</span>
                                                                        </div>
                                                                        {leuAviso && (
                                                                            <div style={{ color: '#73fa04', fontWeight: 'bold', width: '100%', textAlign: 'right' }}>(Lido)</div>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                                )
                                                            }) : 'Nenhum destinatário disponível.'}
                                                    </div>
                                                 </> 
                                                {/* ) : <></>} */}
                                            
                                            {/* Datas e Criados */}
                                            <div className="d-flex flex-column divForm pt2">
                                                <div className="w100">
                                                    <div className='text-align-left d-flex fs12 flex-column'>
                                                        <label>{aviso.aviCriadoPor ? 'Criado: ' + aviso.aviCriadoPor + '' : 'Usuário Desconhecido'} {aviso.aviCriadoEm ? ' - ' + aviso.aviCriadoEm : ''}</label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                {errorMessage !== '' && errorMessage !== false ? errorMessage : ''}
                                            </div>

                                            {/* Botão Salvar */}
                                            {parseInt(sessionStorage.pesAdmin) === 1 
                                            || loggedIn === null 
                                            || loggedIn === false
                                            || parseInt(sessionStorage.IdPessoa) === parseInt(campos.IdPessoa)
                                            || parseInt(campos.IdPessoa) === 0 ? (
                                            <div className='text-align-left mt2 mb2 divForm fs14'>
                                                <button onClick={handleFormSubmit}
                                                className='buttonModalPadrao pt1 pb1 w100 fs14'
                                                type="submit">
                                                    SALVAR AVISO
                                                </button>
                                            </div> ) : ('')}

                                        </div>
                                    {/* </form> */}
                                </div>
                          ) : (
                            <div>
                                <div className="headerMain">
                                    <label className='labelTitulo fs16' >Leitura do Aviso</label>
                                </div>

                                <div className="d-flex w100 flex-column tdAlignLeft pb4">
                                    <div className="d-flex flex-row divForm">
                                        <div className="w100">
                                            <div className='text-align-left divForm fs12'>
                                                <label className='labelTitulo fs14'>TÍTULO</label>
                                            </div>
                                            <div className='text-align-left divForm w100 fs12 mt1 mb2'>
                                                <label className="pt1 pb1 p1 fs12 w100 text-align-left" >
                                                    {aviso.aviTitulo}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    {/* Descrição do Aviso */}
                                    <div className="d-flex flex-row divForm">
                                        <div className="w100">
                                            <div className='text-align-left divForm fs12'>
                                                <label className='labelTitulo fs14'>DESCRIÇÃO</label>
                                            </div>
                                            <div className='text-align-left divForm w100 fs12 mt1 mb2'>
                                                <label className="pt1 pb1 p1 fs12 w100 text-align-left" >   
                                                    {aviso.aviDescricao}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                     {/* Observações do Aviso */}
                                     <div className="d-flex flex-row divForm">
                                        <div className="w100">
                                            <div className='text-align-left divForm fs12'>
                                                <label className='labelTitulo fs14'>OBSERVAÇÕES</label>
                                            </div>
                                            <div className='text-align-left divForm w100 fs12 mt1 mb2'>
                                                <label className="pt1 pb1 p1 fs12 w100 text-align-left" >   
                                                    {aviso.aviObservacoes}
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                          )}
                    </div>
                </div>
            </main>
        </div>
    );
}

export default Aviso;